<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <VAModal ref="md" modalCls="modal-lg">
          <template v-slot:title>Cấu hình email</template>
          <template v-slot:body>
            <form>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-2 col-form-label">Mã email</label>
                <div class="col-sm-10">
                  <input class="form-control" id="inputStatusName" v-model="newItemData.code">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-2 col-form-label">Tên email</label>
                <div class="col-sm-10">
                  <input class="form-control" id="inputStatusName" v-model="newItemData.email_name">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-2 col-form-label">Nội dung</label>
                <div class="col-sm-10">
                  <editor
                    api-key="ak2zkjglxl3mzwdynk7x9a9mkxb72ij1iphfnyq317ic3yg2"
                    v-model="newItemData.content"
                    :init="{
                       height: 300,
                       menubar: false,
                       plugins: [
                         'advlist autolink lists link image charmap print preview anchor',
                         'searchreplace visualblocks code fullscreen',
                         'insertdatetime media table paste code help wordcount'
                       ],
                       toolbar:
                         'undo redo | formatselect | bold italic backcolor | \
                         alignleft aligncenter alignright alignjustify | \
                         bullist numlist outdent indent | removeformat | help'
                     }"
                  />
                </div>
              </div>

              <div class="from-group row">
                <label class="col-sm-2 col-form-label">Mẫu thay thế trong nội dung</label>
                <div class="col-sm-10">
                  <div>
                    <table class="table table-bordered">
                      <tbody>
                      <tr>
                        <th style="width: 10px">#</th>
                        <th>Cú pháp</th>
                        <th>Nội dung thay thế</th>
                      </tr>
                      <tr v-for="(item, idx) in emailSynstax" :key="idx">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ item.code }}</td>
                        <td>
                          {{ item.description }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:save-button>
            <button type="button" class="btn btn-sm btn-pink" @click="add">
              <span aria-hidden="true" class="glyphicon glyphicon-ok"></span> Lưu
            </button>
          </template>
        </VAModal>
        <va-box theme="box-primary" title="Danh sách cấu hình email">
          <div slot="content" class="container-fuild">
            <div class="row">
              <div class="form-group col-4">
                <label>Tìm kiếm</label>
                <div class="d-flex">
                  <input type="text" class="form-control" v-model="filterData.email_name"
                         placeholder="Nhập từ khoá: tên, mã email..."/>
                  <b-button class="btn btn-sm btn-success ml-3" @click="search">
                    <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
                  </b-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="btn btn-sm btn-warning" @click="$router.back()">
                  <span class="glyphicon glyphicon-backward" aria-hidden="true"></span> Quay lại
                </b-button>
                <b-button class="btn btn-sm btn-danger" @click="openModalAdd()">
                  <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Thêm mới
                </b-button>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                         show-empty>
                  <template #table-busy>
                    <div class="text-center my-2 mt-5 mb-5">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Đang tải...</strong>
                    </div>
                  </template>
                  <template #empty="scope">
                    <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="edit(data.item)">
                      <i class="fa fa-edit"/>
                    </b-button>
                    <b-button variant="danger" v-b-tooltip.hover title="Xoá"
                              @click="remove(data.item.id, data.item.email_name)">
                      <i class="fa fa-trash"/>
                    </b-button>
                  </template>
                  <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at | format_date }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import Utils from '../../common/utils'
import Editor from '@tinymce/tinymce-vue'
import VAModal from '../../components/VAModal'
import {mapGetters} from 'vuex'
import EmailTemplateApi from '../../api/emailTemplate'
import EmailSyntaxApi from '../../api/emailSyntax'

export default {
  name: 'EmailTemplate',
  components: {
    VAModal,
    'va-box': VABox,
    Editor,
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  data () {
    return {
      filterData: {
        name: null,
      },
      items: [],
      fields: [
        {
          key: 'code',
          label: 'Mã'
        },
        {
          key: 'email_name',
          label: 'Tên email'
        },
        {
          key: 'created_at',
          label: 'Ngày tạo'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      emailSynstax: [],
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      newItemData: {
        id: null,
        email_name: '',
        content: '',
        company_id: '',
      }
    }
  },
  mounted () {
    this.filter()
    const company = Utils.getCompanyByUserInfo(this.userInfo)
    this.newItemData.company_id = company.id
    EmailSyntaxApi.filter({name: ''}, 0, 20).then(res => {
      this.emailSynstax = res.data.data.records
    })
  },
  methods: {
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      // Check filter data here
      EmailTemplateApi.filter(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    add () {
      if (!this.newItemData.id && this.newItemData.email_name && this.newItemData.content && this.newItemData.code) {
        this.loading = true
        EmailTemplateApi.create(this.newItemData)
          .then((res) => {
            Utils.successToast(this.$bvToast)
            this.items.push(res.data.data)
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.$refs.md.hide()
            this.reset()
          })
      }

      if (this.newItemData.id) {
        this.loading = true
        EmailTemplateApi.update(this.newItemData)
          .then((res) => {
            Utils.successToast(this.$bvToast)
            const copyId = this.newItemData.id
            const i = this.items.findIndex(v => v.id === copyId)
            let copyItem = [...this.items]
            copyItem[i] = res.data.data
            this.items = copyItem
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.$refs.md.hide()
            this.reset()
          })
      }
    },
    openModalAdd () {
      this.reset()
      this.$refs.md.show()
    },
    reset () {
      this.newItemData.id = ''
      this.newItemData.code = ''
      this.newItemData.email_name = ''
      this.newItemData.content = ''
    },
    edit (item) {
      this.newItemData.id = item.id
      this.newItemData.code = item.code
      this.newItemData.email_name = item.email_name
      this.newItemData.content = item.content
      this.$refs.md.show()
    },
    remove (id, name) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Xóa "' + name + '". Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            EmailTemplateApi.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    goDetail (id) {

    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/EmailTemplate.vue